import React from 'react';
// import X from '../../icons/X';
// import Check from '../../icons/Check';

export interface IFormInputData {
    value: number;
    max: number;
}

const ProgressBar = (props: IFormInputData) => {
    const { value, max } = props
    // const percent = Math.round((value / max) * 100.0);

    return (
        <div className="w-full flex flex-col justify-center items-start text-text-dark">
            <div className="w-full inline-flex justify-start items-center">
                <div className="ReportedTransactionsProgress self-stretch justify-start text-text-dark text-sm font-semibold font-['Inter'] leading-tight">Confirmed Receipts Progress</div>
                <div className="w-16 flex-1 text-right justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">{value} / {max}</div>
            </div>
            {/* <div className="Input w-80 h-2.5 bg-bg-input-locked rounded-lg outline outline-1 outline-offset-[-0.50px] outline-border-default inline-flex justify-start items-center overflow-hidden">
                <div className={`w-[${percent}%] h-2 p-2 relative bg-buttons-primary rounded-sm`} />
            </div> */}
        </div>
    );
};

export default ProgressBar;